import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Heading, cn } from "@pcln/horizon";
import { searchFormCard } from "./SearchFormCard.variants.js";
const SearchFormCard_SearchFormCard = /*#__PURE__*/ forwardRef(function({ 'aria-label': ariaLabel = 'Search form', children, className, contentClassName, headline, role = 'region', subheadline, variant = 'panel', width = 'full', ...props }, ref) {
    const styles = searchFormCard({
        variant,
        width
    });
    return /*#__PURE__*/ jsxs("div", {
        "aria-label": ariaLabel,
        className: cn(styles.root(), className),
        ref: ref,
        role: role,
        ...props,
        children: [
            (headline || subheadline) && /*#__PURE__*/ jsxs("div", {
                className: styles.header(),
                children: [
                    headline && /*#__PURE__*/ jsx(Heading, {
                        as: "h1",
                        textStyle: "heading2",
                        children: headline
                    }),
                    subheadline && /*#__PURE__*/ jsx(Heading, {
                        as: "h2",
                        textStyle: "subheading4",
                        className: "font-normal",
                        children: subheadline
                    })
                ]
            }),
            /*#__PURE__*/ jsx("div", {
                className: cn(styles.content(), contentClassName),
                children: children
            })
        ]
    });
});
export { SearchFormCard_SearchFormCard as SearchFormCard };
